import { dropBoolean } from 'utils/drops';

const getModeloFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'modelo',
    label: 'Modelo',
    initial: true,
  },
  {
    name: 'marca',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
  },
  {
    name: 'anofab',
    label: 'Ano de Fabricação',
    type: 'number',
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropBoolean,
  },
];

export default getModeloFilterFields;
